import { render, staticRenderFns } from "./GroupInnerItem.vue?vue&type=template&id=15f23aba&scoped=true&"
import script from "./GroupInnerItem.vue?vue&type=script&lang=js&"
export * from "./GroupInnerItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupInnerItem.vue?vue&type=style&index=0&id=15f23aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f23aba",
  null
  
)

export default component.exports